export default "__VITE_ASSET__CimyLtpv__"